module.exports = __webpack_public_path__ + "img/logo.f3ef8ce4.png";